export default "__VITE_ASSET__d7d8e60d__"